import AlertBox from "@components/AlertBox/AlertBox"
import Header from "@components/Header/Header"
import MenuItem from "@components/MenuItem/MenuItem"
import SectionLabel from "@components/SectionLabel/SectionLabel"
import { CRIMSON_100 } from "@styles/colors"
import { useNavigate } from "react-router"
import { Container, ContentContainer, MenuItemContainer, AlertBoxContainer } from "./Security.styles"
import { useTranslation } from "react-i18next"
import { Biometrics } from "@lib/telegram"

const Security = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    return (
        <Container>
            <Header title={t('security.header')} showBackButton={true} onBackClick={() => navigate('/settings')} />
            <ContentContainer>
                <SectionLabel>{t('security.sectionLabel')}</SectionLabel>
                <MenuItemContainer>
                    <MenuItem 
                        title={t('security.menuItems.changePin')}
                        onClick={() => navigate('/change-pin')}
                    />
                    {Biometrics.isBiometricsInited() && Biometrics.isAvailable() && <MenuItem 
                        title={t('security.menuItems.biometrics')}
                        onClick={() => {
                            navigate('/authentication', {
                                state: { 
                                    operationType: 'biometrics',
                                    successRoute: '/biometrics',
                                    headerTitle: t('authentication.biometrics.title').toUpperCase(),
                                } 
                            })
                        }}
                    />}
                </MenuItemContainer>
            </ContentContainer>
            <AlertBoxContainer>
                <AlertBox 
                    alertText={t('security.alertText')}
                    textAlign="center"
                    enableIcon={false}
                    backgroundColor={CRIMSON_100}
                    borderColor={CRIMSON_100}
                    fontSize="14px"
                />
            </AlertBoxContainer>
        </Container>
    )
}

export default Security